const faqs = [
  {
    q: 'What is itaobuy spreadsheet?',
    a: 'The itaobuy spreadsheet is a structured product sourcing system designed to simplify buying from China. It replaces complex agent communication with a clear, organized spreadsheet interface where buyers can browse products, submit orders, and track shipments all in one place. The system is built for global buyers, resellers, and sourcing agents who need an efficient, transparent way to purchase products from Chinese suppliers.',
  },
  {
    q: 'Is itaobuy spreadsheet safe to use?',
    a: 'Yes, the itaobuy spreadsheet system is safe and reliable. It includes secure payment handling through verified channels, complete order tracking transparency, a verified supplier verification process, and shipping protection on all international orders. The spreadsheet format ensures every transaction is documented and traceable, giving buyers full confidence in their purchases.',
  },
  {
    q: 'How does itaobuy spreadsheet work?',
    a: 'Using itaobuy spreadsheet is straightforward. First, you browse the product spreadsheet organized across 14 categories. Next, you select the product links for items you want. You then submit your order request through the system. A dedicated agent processes the purchase, items arrive at the consolidation warehouse for inspection, and finally your consolidated package ships internationally with full tracking.',
  },
  {
    q: 'How much does itaobuy spreadsheet cost?',
    a: 'The itaobuy spreadsheet system is designed to be cost-effective. Compared to traditional buying agents who charge high commissions, the spreadsheet model reduces service fees significantly. You pay for the actual product cost plus transparent processing and shipping fees - no hidden charges or surprise markups. Bulk orders receive even better rates.',
  },
  {
    q: 'Can beginners use itaobuy spreadsheet?',
    a: 'Absolutely. The itaobuy spreadsheet is specifically designed to be beginner-friendly. Even if you have never sourced products from China before, the step-by-step workflow guides you through the entire process. The spreadsheet format is familiar and intuitive, and support is available if you need help at any stage of your order.',
  },
];

export default function FAQSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-secondary-50">
      <div className="max-w-[800px] mx-auto text-center">
        <p className="text-foreground-400 text-xs font-semibold uppercase tracking-[0.2em] mb-12">
          Common Questions
        </p>

        <div className="space-y-10">
          {faqs.map((faq, idx) => (
            <div key={idx}>
              <h4 className="text-foreground-900 font-semibold text-lg md:text-xl mb-3">
                {faq.q}
              </h4>
              <p className="text-foreground-600 text-sm md:text-base leading-relaxed max-w-[650px] mx-auto">
                {faq.a}
              </p>
            </div>
          ))}
        </div>

        <p className="mt-12 text-foreground-400 text-sm">
          Still have questions about itaobuy spreadsheet? Visit our main platform for detailed support.
        </p>
      </div>
    </section>
  );
}